import { getQuestionsAnswers, getQuestions, submitQuestionAnswers } from './action';

export { questionsReducer } from './reducer';
export { watchQuestions } from './saga';
export {
  GET_QUESTIONS_ANSWERS,
  GET_QUESTIONS_ANSWERS_SUCCESS,
  SUBMIT_QUESTION_ANSWERS,
} from './types';

export const questionsActions = {
  getQuestionsAnswers,
  getQuestions,
  submitQuestionAnswers,
};
